import React, { useEffect, useState, useContext } from "react";
import ValueContext from "../../ContextAPi/appContext";
import Dialog from "@mui/material/Dialog";
import ModulesScreen from "./ModulesScreen.js";
import "../../styles/components/ModulesScreen.scss";
import ModuleRuleSets from "./ModuleRuleSets.js";
import { getmmModules, putGotoEditorModules, fetchModuleDetails } from "../../services/apis.js";
import ErrComponentToRender from "../../Uitls/apiErrorHandling";
import { toast } from "react-toastify";
import {  useLocation } from "react-router-dom";

const ModulesModal = ({
  handleOpenModuleModal,
  classes,
  openModulesModal,
  setOpenModulesModal,
  openModulesScreen,
  setOpenModulesScreen,
  setSelectedModulecards,
  selectedModulecards,
  setIsNext,
  brandName,
  countryName,
  setModuleCardsDataLHS,
  moduleCardsDataLHS,
  isLoading,
  setIsLoading,
  handleExpandModuleClaims,
  getEditSaveAssets,
  bannerId,
  setModuleSearchExpression,
  moduleSearchExpression,
  setBgClass,
  setMlrstatuses,
  mlrStatuses,
  setLayerCompData,
  layerCompData,
  setRemoveSymbol,
  setState,
  setBannerValidationCheck,
}) => {
  const categoriesErr = (value) => {
    toast.error(value, { position: toast.POSITION.TOP_RIGHT });
  };
  const appData = useContext(ValueContext);
  const [openRuleSetModal, setOpenRuleSetModal] = useState(false);
  const [selectedChecked, setSelectedChecked] = useState(false);
  const [modulePreviewData, setModulePreviewData] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [modulePreviewOpen, setModulePreviewOpen] = useState(false);
  const [modulesModaldata, setModulesModalData] = useState({
    brand: "Biktarvy",
    country: "Spain",
  });
  const [searchText, setSearchText] = useState("");
  const [isLoadingModule, setIsLoadingModule] = useState(false);
  const [modulesData, setModulesData] = useState([]);
  const [submittedQuery, setSubmittedQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedIndications, setSelectedIndications] = useState([]);
  const location = useLocation();
  const state = location.state || {};
  const [hasMore,setHasMore]=useState(true)
  const [isPreSelectedDone,setIsPreSelectedDone]=useState(false);
    useEffect(() => {
      if (modulesData.length && !isPreSelectedDone) {
        let filteredData = modulesData.filter((module) =>
          moduleCardsDataLHS.some((card) => card.moduleId === module.id)
        );
        setSelectedModulecards(filteredData);
        if (filteredData.length !== moduleCardsDataLHS.length && currentPage < 20) {
          setCurrentPage(currentPage + 1);
        }
        else{
          setIsPreSelectedDone(true);
        }
      }
    }, [modulesData]);
  
  useEffect(() => {
    searchmmModules();
  }, [currentPage, selectedIndications, submittedQuery]);


   const searchmmModules = () => {
    setIsLoadingModule(true);

    const indicationIds = selectedIndications
      .map((item) => item.label)
      .filter(Boolean);


    const payLoad = {
      page: currentPage - 1,
      productName: appData?.genericInfo?.brand || state?.brandName || "",
      countryName: appData?.genericInfo?.market || state?.countryName || "",
      searchText: submittedQuery,
      topicName: "",
      subtopicName: "",
      segmentNames: [],
      indicationIds,
    };

    getmmModules(payLoad, (response, err) => {
      if (err) {
        console.log("error", err);
        setIsLoadingModule(false);
      } else {
        const newModules = response?.data?.data || [];
        setModulesData((prevModules) =>
          currentPage === 1 ? newModules : [...prevModules, ...newModules]
        );
        setHasMore(!response?.data?.last);
        setIsLoadingModule(false);
      }
    });
  };
  

  const handleOpenModal = (type) => {
    if (type === "moduleCards") {
      setSubmittedQuery('')
      setOpenModulesScreen(false);
      
    setSelectedIndications([]);
      setOpenRuleSetModal(true);
    } else if (type === "rulesets") {
      setSearchText("");
      setOpenModulesScreen(true);
      setOpenRuleSetModal(false);
    }
  };
  const handleSwitchComp = (e, type) => {
    localStorage.setItem(
      "modulesSelected",
      JSON.stringify(selectedModulecards)
    );
    const newChecked = e.target.checked;

    setSelectedChecked(newChecked);
    return newChecked;
  };
  const handleGotoEditor = (moduleBusinessRules) => {
    setBannerValidationCheck(false);
    let extractedModuleData = selectedModulecards.map(
      ({ id, moduleDamName }) => ({
        id,
        moduleDamName,
      })
    );

    setIsLoading(true);
    let contentModules = selectedModulecards.map((rule) => ({
      id: rule.id,
      contentmoduleId: rule.moduleDamId,
      contentmoduleName: rule.moduleDamName,
      moduleName: rule.moduleName,
      productName: rule.productName,
      countryName: rule.countryName,
    }));
    let searchExpression = {
      productName: brandName,
      countryName: countryName,
      searchText: searchText,
    };

    let linkedModules = { linkedModules: "veevaModule" };
    let moduleType = "contentmodule";
    let finalObj = {
      contentModules,
      searchExpression,
      linkedModules,
      moduleType,
    };

    let moduleInfo = { assetId: appData.assetInfo.assetId, finalObj };
    let allIds;
    try {
      allIds = JSON.parse(localStorage.getItem("allBannersForVeevaId")) || [];
    } catch (error) {
      allIds = [];
    }

    let modulesPayload = allIds?.map(item => {
      return {
        ...finalObj, assetId: item?.value
      }
    })


    putGotoEditorModules(modulesPayload, (response, err, errorCode) => {
      if (err) {
        const errCoponent = ErrComponentToRender(errorCode);
        categoriesErr(errCoponent);
        setIsLoading(false);
      } else {
        let putResp = response.data;

        setModuleCardsDataLHS(putResp);
        setIsLoading(false);
        getEditSaveAssets(bannerId,true);

      }
    });
    setState({...state, newBanner: false});
  };
  const getModuleDetailsForPreview = (moduleId) => {
    setLoading(true);
    fetchModuleDetails(moduleId, (res, err, errCode) => {
      if (err) {
        setLoading(false);
        const errCoponent = ErrComponentToRender(errCode);
        toast.error(errCoponent);
      } else {
        setLoading(false);
        setModulePreviewData(res.data);
        setModulePreviewOpen(true);
      }
    });
  };
  return (
    <div>
      <Dialog
        className=" modulesModalContainer"
        open={openModulesModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        {openModulesScreen && (
          <ModulesScreen
            setRemoveSymbol={setRemoveSymbol}
            isLoading={isLoadingModule}
            hasMore={hasMore}
            getmmModules={getmmModules}
            state={state}
            selectedIndications={selectedIndications}
            setSelectedIndications={setSelectedIndications}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            setSubmittedQuery={setSubmittedQuery}
            submittedQuery={submittedQuery}
            setModulePreviewData={setModulePreviewData}
            setLoading={setLoading}
            setModulePreviewOpen={setModulePreviewOpen}
            modulePreviewData={modulePreviewData}
            modulePreviewOpen={modulePreviewOpen}
            handleOpenModal={handleOpenModal}
            selectedChecked={selectedChecked}
            setSelectedChecked={setSelectedChecked}
            handleSwitchComp={handleSwitchComp}
            modulesData={modulesData}
            setModulesData={setModulesData}
            selectedModulecards={selectedModulecards}
            setSelectedModulecards={setSelectedModulecards}
            setModulesModalData={setModulesModalData}
            modulesModaldata={modulesModaldata}
            searchText={searchText}
            setSearchText={setSearchText}
            brandName={brandName}
            countryName={countryName}
            setOpenModulesModal={setOpenModulesModal}
            moduleCardsDataLHS={moduleCardsDataLHS}
            handleGotoEditor={handleGotoEditor}
            setOpenModulesScreen={setOpenModulesScreen}
            setOpenRuleSetModal={setOpenRuleSetModal}
            setIsNext={setIsNext}
            //selectedModulesList={selectedModulecards }
            setModuleCardsDataLHS={setModuleCardsDataLHS}
            moduleSearchExpression={moduleSearchExpression}
            setModuleSearchExpression={setModuleCardsDataLHS}
            setBgClass={setBgClass}
            getModuleDetailsForPreview={getModuleDetailsForPreview}
          //   selectedModulesList={
          //    [
          //     {
          //       moduleDamName: "CM-000305",
          //     },
          //     {
          //       moduleDamName: "CM-000174",
          //     },

          //   ]
          // }
          />
        )}
        {openRuleSetModal && (
          <ModuleRuleSets
            setModulePreviewData={setModulePreviewData}
            setLoading={setLoading}
            setModulePreviewOpen={setModulePreviewOpen}
            modulePreviewOpen={modulePreviewOpen}
            modulePreviewData={modulePreviewData}
            setMlrstatuses={setMlrstatuses}
            mlrStatuses={mlrStatuses}
            handleOpenModal={handleOpenModal}
            handleSwitchComp={handleSwitchComp}
            selectedChecked={selectedChecked}
            openModulesModal={openModulesModal}
            setOpenModulesModal={setOpenModulesModal}
            setOpenModulesScreen={setOpenModulesScreen}
            setOpenRuleSetModal={setOpenRuleSetModal}
            setIsNext={setIsNext}
            openRuleSetModal={openRuleSetModal}
            modulesData={modulesData}
            setModulesData={setModulesData}
            selectedModulecards={selectedModulecards}
            setSelectedModulecards={setSelectedModulecards}
            handleGotoEditor={handleGotoEditor}
            handleExpandModuleClaims={handleExpandModuleClaims}
            setBgClass={setBgClass}
            getModuleDetailsForPreview={getModuleDetailsForPreview}
          />
        )}
      </Dialog>
    </div>
  );
};

export default ModulesModal;
